import 'intersection-observer'
import * as React from 'react'
import { AsyncState, IOWidget, Updater, async, fromJSX } from 'widgets-for-react'
import { PublicSiteState } from '../../../../../../../root/state'
import { CMSState, Link } from '../../../../cms/blocks/types.gen'
import { getClassName, link } from '../../../../cms/blocks/utils.gen'
import { PaginatedItem } from '../../../../drupal/types_and_parser/extra_types.mod'
import { ParsedNodeStory } from '../../../../drupal/types_and_parser/types.ext.gen'
import { ParsedImageFileWithTargetItem } from '../../../../drupal/types_and_parser/types.ext.mod'
import { InnerHtmlWrapper } from '../../../../utils/InnerHtmlWrapper'

export type storiesBlockProps = {
  block_index: number
  stories: AsyncState<PaginatedItem<ParsedNodeStory>>
  title: string
  link: Link
}

export type story = {
  title: string
  introduction?: string
  image?: ParsedImageFileWithTargetItem
  link?: Link
}

export type storiesBlockStyle = Partial<{
  block_classname: string
  inview_classname: string
  inner_classname: string
  content_classname: string
  quote_classname: string
  footer_classname: string
  author_classname: string
  clickable_classname: string
  visual_classname: string
  image_classname: string
}>

export function storiesBlock(
  props: storiesBlockProps,
  options?: { style: storiesBlockStyle; key?: string }
): (s: CMSState) => IOWidget<PublicSiteState, Updater<CMSState>> {
  return (s: CMSState) => (public_state: PublicSiteState) =>
    fromJSX((setState) => (
      <section className="block block--stories">
        <div className="block__inner">
          {props.title ? (
            <header className="block__header ls-container">
              {props.title && <h2 className="block__title title--l">{props.title}</h2>}
            </header>
          ) : (
            <></>
          )}

          <div className="block__content">
            {async(props.stories).run((a) => {
              setState((s0) => {
                let block = s0.blocks.get(props.block_index)
                block.value[0].stories = a(block.value[0].stories)
                return { ...s0, blocks: s0.blocks.set(props.block_index, block) }
              })
            })}
            {props.stories.kind == 'loaded' ? (
              <div className="block__ls-container">
                <ul className="block__list grid">
                  {/* TODO marielle */}
                  {props.stories.value.items.slice(0, 3).map((story) => {
                    // return storyItem(story, getLangFromUrl())
                    return <></>
                  })}
                </ul>
              </div>
            ) : (
              props.stories.kind
            )}

            {props.link && (
              <footer className="block__footer ls-container">
                {link(props.link, { classname: 'link' }, props.link.title)}
              </footer>
            )}
          </div>
        </div>
      </section>
    ))
}

const story = (story: story, options?: { style: storiesBlockStyle; key?: string }) => (
  <div>
    <h3>{story.title}</h3>
    {story.introduction && (
      //<div dangerouslySetInnerHTML={{__html: story.introduction}}/>
      <InnerHtmlWrapper text={story.introduction} />
    )}

    {story.image && <img loading="lazy" src={story.image.image.style_urls.grid} alt={story.image.alt} />}

    {story.link && (
      <footer className={getClassName(options, 'footer_classname', '')}>
        <div className={''}>
          {' '}
          {/* TODO : Set classname*/}
          {link(story.link, { classname: 'classname' } /* TODO : Set classname */, story.link.title)}
        </div>
      </footer>
    )}
  </div>
)
